export const storeMutation = {
    //store mutations
    setLoggedUser: 'setLoggedUser',
    removeLoggedUser: 'removeLoggedUser',
    resetState: 'resetState',
    handleCancelableRequest: 'handleCancelableRequest',
    removeCancelableRequest: 'removeCancelableRequest',
    handleActivityFeedCancelableRequest: 'handleActivityFeedCancelableRequest',
    removeActivityFeedCancelableRequest: 'removeActivityFeedCancelableRequest',
    handleParamConfig: 'handleParamConfig',
    setCoreConfigLoadingState: "setCoreConfigLoadingState",

    //auth module mutations
    setSessionToken: 'setSessionToken',
    setPostLoginRedirectRoute: 'setPostLoginRedirectRoute',
    setSessionExpirationTime: 'setSessionExpirationTime',
    setAccessTokenExpirationTime: 'setAccessTokenExpirationTime',
    setRecoveryOptions: 'setRecoveryOptions',
    setPasswordRecoveryOptions: 'setPasswordRecoveryOptions',
    setSelectedRecoveryCodeType: 'setSelectedRecoveryCodeType',
    setPasswordResetToken: 'setPasswordResetToken',
    setLoginErrorMessage: 'setLoginErrorMessage',
    setFromLogoutSession: 'setFromLogoutSession',
    setUserRecoveryOptions: 'setUserRecoveryOptions',
    setPasswordFurtherAssistance: 'setPasswordFurtherAssistance',
    setSelectTypePasswordDelivery: 'setSelectTypePasswordDelivery',
    setStateToken: 'setStateToken',
    prepareAdditionalSecurityObjectForPassword: 'prepareAdditionalSecurityObjectForPassword',
    setPermissionsData: 'setPermissionsData',
    setIsExceptionOccurredOnGetPermissions: 'setIsExceptionOccurredOnGetPermissions',
    setSystemMessages: 'setSystemMessages',
    setAdobeRegistrationResponse: 'setAdobeRegistrationResponse',

    //ypo Search mutations:
    setPeopleOneClickSearchSuggestions: 'setPeopleOneClickSearchSuggestions',
    setPeopleSearchSuggestions: 'setPeopleSearchSuggestions',
    setEventSearchSuggestions: 'setEventSearchSuggestions',
    setCommunitySearchSuggestions: 'setCommunitySearchSuggestions',
    setContentSearchSuggestions: 'setContentSearchSuggestions',
    resetSearchSuggestions: 'resetSearchSuggestions',

    //chapter module mutations
    toggleCATools: 'toggleCAToolsView',
    toggleOverallChapterHealth: 'toggleOverallChapterHealth',
    setChapterActivityList: 'setChapterActivityList',
    resetChapterActivityList: 'resetChapterActivityList',
    setInfiniteScrollState: 'setInfiniteScrollState',
    editPost: 'editPost',
    closePostEditor: 'closePostEditor',
    setPostChangePending: 'setPostChangePending',
    updatePostLocally: 'updatePostLocally',
    updatePostAfterRemovingMention: 'updatePostAfterRemovingMention',
    deletePostLocally: 'deletePostLocally',
    inappropriatePostLocally: 'inappropriatePostLocally',
    setUserProfile: 'setUserProfile',
    setImpersonationRole: 'setImpersonationRole',
    setUpdatedUserProfile: 'setUpdatedUserProfile',
    addNewPostToList: 'addNewPostToList',
    updateCommentsToDisplay: 'updateCommentsToDisplay',
    updateParentPostWithShowMore: 'updateParentPostWithShowMore',
    updateParentPostWithShowLess: 'updateParentPostWithShowLess',
    addShowMoreTriggeredPostToState: 'addShowMoreTriggeredPostToState',
    removeShowMoreTriggeredPostFromState: 'addShowMoreTriggeredPostFromState',
    handleHiddenPost: 'handleHiddenPost',
    handleUnHideOfAPost: 'handleUnHideOfAPost',
    setChairMessage: 'setChairMessage',
    setChapterMessage: 'setChapterMessage',
    UpdateChairMessage: 'UpdateChairMessage',
    handleUnHidePost: 'handleUnHidePost',
    updateUnlikesLocally: 'updateUnlikesLocally',
    updateLikesLocally: 'updateLikesLocally',
    setAboutView: 'setAboutView',
    setTransactionHubContent: 'setTransactionHubContent',
    setChapterAwards: 'setChapterAwards',
    setCommentedUsers: 'setCommentedUsers',
    setLikedUsers: 'setLikedUsers',
    setChapterOfficersData: 'setChapterOfficersData',
    setIsCommunityAdmin: 'setIsCommunityAdmin',
    setModeratedPostCreated: 'setModeratedPostCreated',
    setIsPMTeamMember: 'setIsPMTeamMember',
    setChapterQuickLinks: 'setChapterQuickLinks',
    hideMainActivityFeed: 'hideMainActivityFeed',

    // Upcoming Events
    setUpcomingEventList: 'setUpcomingEventList',
    updateSaveUpcomingEvents: 'updateSaveUpcomingEvents',
    updateRejectUpcomingEvents: 'updateRejectUpcomingEvents',

    //Member Directory
    setMemberDirectorySearchResults: 'setMemberDirectorySearchResults',
    setMemberDirectoryWithLastNameSearchResult: 'setMemberDirectoryWithLastNameSearchResult',
    setMemberDirectorySort: 'setMemberDirectorySort',
    appendToMemberDirectorySearchResults: 'appendToMemberDirectorySearchResults',
    setSkipCount: 'setSkipCount',
    resetRibbonState: 'resetRibbonState',
    setRibbonStateFromRouter: 'setRibbonStateFromRouter',
    setRibbonState: 'setRibbonState',
    setRoutedRibbonState: 'setRoutedRibbonState',
    removeConnectedFromConnection: 'removeConnectedFromConnection',
    setSelectedFilters: 'setSelectedFilters',
    clearRibbonState: 'clearRibbonState',
    removePillFromState: 'removePillFromState',
    setOneClickChapterInState: 'setOneClickChapterInState',
    setSelectedTypeAhead: 'setSelectedTypeAhead',
    setSelectedSubFilter: 'setSelectedSubFilter',
    setMemberDirectoryTypeAhead: 'setMemberDirectoryTypeAhead',
    initializeMemberTypeAhead: 'initializeMemberTypeAhead',
    initializeSubFilters: 'initializeSubFilters',
    setSubFilterList: 'setSubFilterList',
    setTypeAheadResult: 'setTypeAheadResult',
    resetTypeAheadResult: 'resetTypeAheadResult',
    locallySetFollowConnect: 'locallySetFollowConnect',
    removeNestedCheckBoxFilters: 'removeNestedCheckBoxFilters',
    removeSelectedPrivateNetworks: 'removeSelectedPrivateNetworks',
    setMemberConnectionListInState: 'setMemberConnectionListInState',
    setMemberFollowListInState: 'setMemberFollowListInState',
    setMemberDirectorySearchText: 'setMemberDirectorySearchText',
    setMemberDirectoryInfiniteScrollAbility: 'setMemberDirectoryInfiniteScrollAbility',
    setMemberSelectedLetterFilter: 'setMemberSelectedLetterFilter',
    updateMemberSelectedLetterFilter: 'updateMemberSelectedLetterFilter',

    //YPO Resources
    setYpoResources: "setYpoResources",
    handleShowMoreForCategory: "handleShowMoreForCategory",

    //YPO Concierge
    setYpoConciergeTopics: 'setYpoConciergeTopics',
    setYpoConciergeAgentAvailability: 'setYpoConciergeAgentAvailability',
    setConciergeScriptLoadedStatus: 'setConciergeScriptLoadedStatus',
    setConciergeActiveStatue: 'setConciergeActiveStatue',
    setConciergeFeatureFlag: 'setConciergeFeatureFlag',
    setYpoConciergeUser: 'setYpoConciergeUser',

    //Community Directory
    setCommunityDirectorySearchResults: 'setCommunityDirectorySearchResults',
    setCommunityDirectorySort: 'setCommunityDirectorySort',
    appendToCommunityDirectorySearchResults: 'appendToCommunityDirectorySearchResults',
    setCommunityDirectorySearchText: 'setCommunityDirectorySearchText',
    clearCommunityState: 'clearCommunityState',
    setCommunityStateFromRouter: 'setCommunityStateFromRouter',
    setCommunitySelectedFiltersInState: 'setCommunitySelectedFiltersInState',
    removeCommunityPillFromState: 'removeCommunityPillFromState',
    setCommunityDirectoryResults: 'setCommunityDirectoryResults',
    appendToCommunitySearchResult: 'appendToCommunitySearchResult',
    setDisableCommunityDirectoryInfiniteScroll: 'setDisableCommunityDirectoryInfiniteScroll',
    setCommunitySelectedLetterFilter: 'setCommunitySelectedLetterFilter',

    //Content Directory
    setContentDirectorySearchResults: 'setContentDirectorySearchResults',
    setContentDirectorySort: 'setContentDirectorySort',
    appendToContentDirectorySearchResults: 'appendToContentDirectorySearchResults',
    setContentDirectorySearchText: 'setContentDirectorySearchText',
    clearContentState: 'clearContentState',
    setContentStateFromRouter: 'setContentStateFromRouter',
    setContentSelectedFiltersInState: 'setContentSelectedFiltersInState',
    removeContentPillFromState: 'removeContentPillFromState',
    setDisableContentDirectoryInfiniteScroll: 'setDisableContentDirectoryInfiniteScroll',
    setContentSelectedLetterFilter: 'setContentSelectedLetterFilter',

    //Event Directory
    setEventDirectorySearchResults: 'setEventDirectorySearchResults',
    setMemberVoucher: 'setMemberVoucher',
    addVoucherAsFilter: 'addVoucherAsFilter',
    setEventState: 'setEventState',
    setEventStateFromRouter: 'setEventStateFromRouter',
    removeEventPillFromState: 'removeEventPillFromState',
    setSelectedFiltersInState: 'setSelectedFiltersInState',
    setEventSearchText: 'setEventSearchText',
    initializeEventSubFilters: 'initializeEventSubFilters',
    appendToEventSearchResult: 'appendToEventSearchResult',
    setEventDirectorySort: 'setEventDirectorySort',
    setDisableEventDirectoryInfiniteScroll: 'setDisableEventDirectoryInfiniteScroll',
    setEventSelectedLetterFilter: 'setEventSelectedLetterFilter',

    // YPO Events
    setResultForYpoEvents: 'setResultForYpoEvents',
    setUnfilteredYpoEventsState: 'setUnfilteredYpoEventsState',
    setMostRecentlySelectedFacet: 'setMostRecentlySelectedFacet',
    resetYpoEvents: 'resetYpoEvents',
    setYpoEventsSort: 'setYpoEventsSort',
    setYpoEventStateFromRouter: 'setYpoEventStateFromRouter',
    setYpoEventsSearchText: 'setYpoEventsSearchText',
    setYpoEventsRegionsList: 'setYpoEventsRegionsList',
    setYpoEventsInfiniteScrollStatus: 'setYpoEventsInfiniteScrollStatus',
    setMobileFiltersActive: 'setMobileFiltersActive',

    //Region Chapter List
    setChapterList: 'setChapterList',
    setAllChapterList: 'setAllChapterList',
    //END

    setUsersChaptersList: 'setUsersChaptersList',
    setUsersChaptersListPromise: 'setUsersChaptersListPromise',
    setUserCommunityInfo: 'setUserCommunityInfo',
    setusersCommunitiesList: 'setusersCommunitiesList',
    removeResignedCommunityId: 'removeResignedCommunityId',
    setusersCommunitiesListPromise: 'setusersCommunitiesListPromise',
    setProspectsList: 'setProspectsList',
    createVote: 'createVote',
    setVote: 'setVote',
    sendLikeProspect: 'sendLikeProspect',
    unSendLikeProspect: 'unSendLikeProspect',
    updateFeatureEvents: 'updateFeatureEvents',
    updateFeatureEventAfterSave: 'updateFeatureEventAfterSave',
    updateFeatureEventAfterDelete: 'updateFeatureEventAfterDelete',
    updateFeatureEventInEdit: 'updateFeatureEventInEdit',
    setAdminFeedList: 'setAdminFeedList',
    confirmInappropriatePostLocally: 'confirmInappropriatePostLocally',
    setOverallChapterHealth: 'setOverallChapterHealth',

    //sponsor module mutations
    setSponsorList: 'setSponsorList',
    setCanEditSponsor: 'setCanEditSponsor',
    cloneSponsorList: 'cloneSponsorList',
    addObjectToSponsorLists2: 'addObjectToSponsorLists2',
    removeObjectFromSponsorLists2: 'removeObjectFromSponsorLists2',
    updateObjectSponsorLists2: 'updateObjectSponsorLists2',
    getSponsorIconForUpdate: 'getSponsorIconForUpdate',
    getFreshSponsorLists2: 'getFreshSponsorLists2',

    //my account module mutation
    setInactiveSessionDetection: 'setInactiveSessionDetection',
    setSessionExpiryNotice: 'setSessionExpiryNotice',
    updateSessionExpiration: 'updateSessionExpiration',
    setprofileInformation: 'setprofileInformation',
    updateProfileImageUrl: 'updateProfileImageUrl',
    setUsernameResponse: 'setUsernameResponse',
    setPasswordResponse: 'setPasswordResponse',
    toggleMainPageOverflow: 'toggleMainPageOverflow',
    setCurrentCommunityView: 'setCurrentCommunityView',
    setProfileInformationUsername: 'setProfileInformationUsername',
    setProfileInfoUpdatedFromSpeaker: 'setProfileInfoUpdatedFromSpeaker',

    //Privacy Settings mutation
    setnotification: 'setnotification',
    setVisibilityInformation: 'setVisibilityInformation',
    setEmailPreferences: 'setEmailPreferences',
    setEmailPreferencesResponse: 'setEmailPreferencesResponse',

    //fileAndMedia
    setFilesandMediaList: 'setFilesandMediaList',
    setChapterAdminForumManagementDetails: 'setChapterAdminForumManagementDetails',
    setChapterOfficerManagemet: 'setChapterOfficerManagemet',
    setChapterAdminProspectManagement: 'setChapterAdminProspectManagement',
    setchapterAdminProspectsReadyToPay: 'setchapterAdminProspectsReadyToPay',
    updateFilesAndMediaList: 'updateFilesAndMediaList',
    renameFilesAndMedia: 'renameFilesAndMedia',
    deleteFilesAndMedia: 'deleteFilesAndMedia',
    setDownloadFiles: 'setDownloadFiels',
    setDownloadFolders: 'setDownloadFolders',

    //Tools Menu mutation
    setResourceLinks: 'setResourceLinks',
    setMyQuickLinks: 'setMyQuickLinks',
    setForumQuickLinks: 'setForumQuickLinks',

    //ypoError
    setYpoErrorData: 'setYpoErrorData',

    //News Feed
    setNewsFeed: 'setNewsFeed',
    updateNewsFeed: 'updateNewsFeed',

    //Member profile mutation
    setYPOAwards: 'setYPOAwards',
    setBiography: 'setBiography',
    setTrainingAndCertifications: 'setTrainingAndCertifications',
    setAccomplishments: 'setAccomplishments',
    setProfessionalRoles: 'setProfessionalRoles',
    setCompanyInvestments: 'setCompanyInvestments',
    setFamilyInterests: 'setFamilyInterests',
    setFamilyDetails: 'setFamilyDetails',
    setEducationDetails: 'setEducationDetails',
    setContactInformation: 'setContactInformation',
    setNetworkChapters: 'setNetworkChapters',
    setNetworkRegions: 'setNetworkRegions',
    setSelectedNetwork: 'setSelectedNetwork',
    setNetworks: 'setNetworks',
    setCommunities: 'setCommunities',
    setAllNetworks: 'setAllNetworks',
    setNetworkPageContent: 'setNetworkPageContent',
    setEvents: 'setEvents',
    setCommunityPendingRequests: 'setCommunityPendingRequests',
    setMyActivity: 'setMyActivity',
    setCurrentUserId: 'setCurrentUserId',
    checkCookiePolicyAcceptance: 'checkCookiePolicyAcceptance',
    setCookiePolicy: 'setCookiePolicy',
    removeCurrentUserId: 'removeCurrentUserId',
    setVcardDetails: 'setVcardDetails',
    setProfessionalExperience: 'setProfessionalExperience',
    setProfileConnection: 'setProfileConnection',
    setProfileFollowing: 'setProfileFollowing',
    setCommunitiesGroup: 'setCommunitiesGroup',
    setIsFamilyInterestsLoading: 'setIsFamilyInterestsLoading',
    setAssetSummaryShortcut: 'setAssetSummaryShortcut',
    setAssetSummary: 'setAssetSummary',
    setCountryAndRegions: 'setCountryAndRegions',
    setPendingAssets: 'setPendingAssets',
    setStreetAddress: 'setStreetAddress',
    setChampionPositions: 'setChampionPositions',
    updateQuickLinks: 'updateQuickLinks',
    setCategoryMaster: 'setCategoryMaster',
    setProfileDropDowns: 'setProfileDropDowns',
    setUserProfileImageExists: 'setUserProfileImageExists',

    //Edit profile mutations
    setEducationSearchResult: 'setEducationSearchResult',
    setCourseAndCertificateSearchResult: 'setCourseAndCertificateSearchResult',
    setCompanyTypes: 'setCompanyTypes',
    setEditProfessionalExperience: 'setEditProfessionalExperience',
    setSaveProfessionalExperience: 'setSaveProfessionalExperience',
    setDeleteProfessionalExperience: 'setDeleteProfessionalExperience',
    setProfessionalExperienceSearchResults: 'setProfessionalExperienceSearchResults',
    setBusinessInterestTypes: 'setBusinessInterestTypes',
    setUpdatePersonExternalConnections: 'setUpdatePersonExternalConnections',
    setSavePersonExternalConnections: 'setSavePersonExternalConnections',
    setProfilePhoto: 'setProfilePhoto',
    setEditProfessionalExperienceResponse: 'setEditProfessionalExperienceResponse',
    setSaveProfessionalExperienceResponse: 'setSaveProfessionalExperienceResponse',
    setSearchProfile: 'setSearchProfile',
    setViewPendingAssetRequest: 'setViewPendingAssetRequest',

    //ChapterAdmin
    setChapterAdmin: 'setChapterAdmin',
    setChapterHealthReport: 'setChapterHealthReport',

    //Forum ToolKit
    setToolKitList: 'setToolKitList',
    setToolKitListContent: 'setToolKitListContent',
    setToolKitExercise: 'setToolKitExercise',
    setSampleForumContent: 'setSampleForumContent',
    setListState: 'setListState',
    setAllListState: 'setAllListState',

    //Network Related Communities
    setRelatedCommunities: 'setRelatedCommunities',
    toggleRequestedMembers: 'toggleRequestedMembers',
    toggleInviteSomeone: 'toggleInviteSomeone',
    toggleRequestedGroups: 'toggleRequestedGroups',
    toggleManageParticipants: 'toggleManageParticipants',
    toggleConfigureGroup: 'toggleConfigureGroup',
    togglePendingAssetRequests: 'togglePendingAssetRequests',
    setCommunityAdminList: 'setCommunityAdminList',
    setIsLastAdmin: 'setIsLastAdmin',
    resetAdminPermission: 'resetAdminPermission',
    setRelatedCommunityMsg: 'setRelatedCommunityMsg',
    setupdateRelatedCommunity: 'setupdateRelatedCommunity',
    deleteRelatedCommunity: 'deleteRelatedCommunity',
    setSubNetworks: 'setSubNetworks',
    setRequestedJoinees: 'setRequestedJoinees',
    setApproveRequest: 'setApproveRequest',
    setInviteeesList: 'setInviteeesList',
    setApplytoJoinNetwork: 'setApplytoJoinNetwork',
    setYPONetworks: 'setYPONetworks',
    setReturnInviteesList: 'setReturnInviteesList',
    setSelectedPostType: 'setSelectedPostType',
    setSelectedNetworkType: 'setSelectedNetwork',
    setVerifiedMembers: 'setVerifiedMembers',
    clearVerifiedMembers: 'clearVerifiedMembers',

    //App notification mutation
    setfcmToken: 'setfcmToken',
    setUnReadNotificationCount: 'setUnReadNotificationCount',

    // Messenger
    createMatrixClient: 'createMatrixClient',
    setMessengerUsername: 'setMessengerUsername',
    setMessengerSessionState: 'setMessengerSessionState',
    setRooms: 'setRooms',
    mergeChatParticipantProfile: 'mergeChatParticipantProfile',
    setParticipantState: 'setParticipantState',
    insertFailedMessage: 'insertFailedMessage',

    //groups
    setGroupFocusList: 'setGroupFocusList',
    setGroupConfigRequest: 'setGroupConfigRequest',
    setPendingRequestList: 'setPendingRequestList',
    updatePendingRequestList: 'updatePendingRequestList',

    // Recommended Events
    setRecommendedEvents: 'setRecommendedEvents',
    updateRecommendedEventsCache: 'updateRecommendedEventsCache',
    setRecommendedMembers: 'setRecommendedMembers',
    setReasonsToConnect: 'setReasonsToConnect',

    // Renewals
    setRenewalStatus: 'setRenewalStatus',

    //Forum Meetings
    setForumMeetings: 'setForumMeetings',

    //Assist Page
    setTopicsForAssistPage: 'setTopicsForAssistPage',
    setUploadNewComingSoonStatus: 'setUploadNewComingSoonStatus',
    setCanUserEdit: 'setCanUserEdit',
    setTourVideoTitle: 'setTourVideoTitle',
    setReleaseNotes: 'setReleaseNotes',

    //Feedback Form
    setFeedbackQuestions: 'setFeedbackQuestions',
    setUpdateQuestion: 'setUpdateQuestion',
    setSubmitFeedback: 'setSubmitFeedback',
    setTakeTourVideos: 'setTakeTourVideos',
    setNewsAndComingSoonFiles: 'setNewsAndComingSoonFiles',
    setUploadedVideoList: 'setUploadedVideoList',
    setDeletedTakeTourVideo: 'setDeletedTakeTourVideo',

    //speaker page
    setMemberAssoicationList: 'setMemberAssoicationList',
    setSpeakerRegistrationStatus: 'setSpeakerRegistrationStatus',
    setLanguagesList: 'setLanguagesList',
    setTopicsList: 'setTopicsList',
    setSelectedTopics: 'setSelectedTopics',
    setFeeRangeList: 'setFeeRangeList',
    setMemberProfileDetails: 'setMemberProfileDetails',
    clearMemberProfileDetails: 'clearMemberProfileDetails',
    setPendingApplicants: 'setPendingApplicants',
    setPendingApplicantsCount: 'setPendingApplicantsCount',
    setReviewedApplicants: 'setReviewedApplicants',
    updateSpeakerEditDetailsToPendingOrApprovalList: 'updateSpeakerEditDetailsToPendingOrApprovalList',
    setCountryList: 'setCountryList',
    setRegionList: 'setRegionList',
    setFeesRange: 'setFeesRange',

    //Chapter Waiver
    setPrintWaiverDetails: 'setPrintWaiverDetails',
    setWaiverTypes: 'setWaiverTypes',
    setListOfWaivers: 'setListOfWaivers',
    setVisibleProspect: 'setVisibleProspect',
    setWaiverQuestions: 'setWaiverQuestions',
    setWaiverDetails: 'setWaiverDetails',
    setChapterMemberCount: 'setChapterMemberCount',
    setPRPRole: 'setPRPRole',
    resetChapterWaiverList: 'resetChapterWaiverList',
    setChapterWaiverListInfiniteScroll: 'setChapterWaiverListInfiniteScroll',

    setSentBackToChapter: 'setSentBackToChapter',
    setSentBackError: 'setSentBackError',
    setStatusAfterSentBackToChapter: 'setStatusAfterSentBackToChapter',
    setCompleteWaiverDetails: 'setCompleteWaiverDetails',
    setWaiverStatusLocally: 'setWaiverStatusLocally',
    setPrpMemberList: 'setPrpMemberList',
    setRegionalCommentsError: 'setRegionalCommentsError',
    setRegionalCommentsSaved: 'setRegionalCommentsSaved',
    setStatusAfterROCommentSaved: 'setStatusAfterROCommentSaved',
    removeLeadFromWaiverList: 'removeLeadFromWaiverList',
    setStatusAfterVote: 'setStatusAfterVote',
    setVoteStatusError: 'setVoteStatusError',
    setFinalizeEmailRecipients: 'setFinalizeEmailRecipients',
    setWaiverAttachmentSaved: 'setWaiverAttachmentSaved',
    setFinalizeStatusError: 'setFinalizeStatusError',
    setSearchResults: 'setSearchResults',
    pushSearchResults: 'pushSearchResults',
    removeSearchResults: 'removeSearchResults',
    setCorporationTypes: 'setCorporationTypes',
    setTitleTypes: 'setTitleTypes',

    //Businesses Page
    setSearchAssets: 'setSearchAssets',
    setFeatureLists: 'setFeatureLists',
    setShowAssetId: 'setShowAssetId',
    resetShowAssetId: 'resetShowAssetId',
    setBusinessCommunityId: 'setBusinessCommunityId',
    setRAInfiniteScrollState: 'setRAInfiniteScrollState',
    setPAInfiniteScrollState: 'setPAInfiniteScrollState',
    setIsBecomeASpeaker: 'setIsBecomeASpeaker',
    setRejectApplicant: 'setRejectApplicant',
    setApproveApplicant: 'setApproveApplicant',
    setSpeakerProfile: 'setSpeakerProfile',
    setScrollPendingApplicantToViewMember: 'setScrollPendingApplicantToViewMember',
    setIsSpeakerApproved: 'setIsSpeakerApproved',
    setCanViewSpeakerAdminDirectory: 'setCanViewSpeakerAdminDirectory',
    setExternalSpeaker: 'setExternalSpeaker',
    setPrevRouteUrlName: 'setPrevRouteUrlName',
    setSpeakerStatus: 'setSpeakerStatus',
    setCurrentlyViewingPendingOrReviewApplicantRecord: 'setCurrentlyViewingPendingOrReviewApplicantRecord',
    setAuthData: 'setAuthData',
    resetAuthTokenStatus: 'resetAuthTokenStatus',

    // Event Attendees page
    setEventAttendees: 'setEventAttendees',
    resetEventAttendees: 'resetEventAttendees',

    // Chapter Health Rating page
    setChapterHealthRating: 'setChapterHealthRating',

    //PoliciesProcedures
    setPoliciesHeadings: 'setPoliciesHeadings',
    setArticleData: 'setArticleData',
    setArticleId: 'setArticleId',

    //Create Events //TODO: - removing all these constants until Beta release if complete
    setTimeZones: 'setTimeZones',
    setChapterEvent: 'setChapterEvent',
    setEventCustomField: 'setEventCustomField',
    setCventLookup: 'setCventLookup',

    //Champs Page
    setComponentForInlineLoader: 'setComponentForInlineLoader',
    setChapterGenderDemographics: 'setChapterGenderDemographics',
    resetInlineLoader: 'resetInlineLoader',
    setCommunityHealthPoints: 'setCommunityHealthPoints',
    setTimeZonesForEmail: 'setTimeZonesForEmail',

    //Champs - Events
    setSubmitEvent: 'setSubmitEvent',
    setEvent: 'setEvent',
    setCommunityUser: 'setCommunityUser',
    setEventInfo: 'setEventInfo',
    setEventCustomFields: 'setEventCustomFields',
    setLaunchEvent: 'setLaunchEvent',
    setNextBoardMeetingEvent: 'setNextBoardMeetingEvent',

    //Ypo Common Components
    setChapterChairMessage: 'setChapterChairMessage',
    setChapterMyQuickLinks: 'setChapterMyQuickLinks',
    setChapterAnnouncement: 'setChapterAnnouncement',
    setChapterAnnouncementData: 'setChapterAnnouncementData',
    setChapterSponsorList: 'setChapterSponsorList',
    setChapterCanEditSponsor: 'setChapterCanEditSponsor',
    setChapterFilesandMediaList: 'setChapterFilesandMediaList',

    //search speaker
    setFeeMaxMinValue: 'setFeeMaxMinValue',
    setSpeakerFilters: 'setSpeakerFilters',

    //Champs Page
    setEmailSenderList: 'setEmailSenderList',
    setEmailRecipient: 'setEmailRecipient',
    setForumCategory: 'setForumcategory',
    setEmailContent: 'setEmailContent',
    setPreviewEmailContent: 'setPreviewEmailContent',
    setAllEmailInformation: 'setAllEmailInformation',
    setLinkingObjects: 'setLinkingObjects',

    //OpenAuth API
    setTermsPrivacyURLs: 'setTermsPrivacyURLs',
    setUnRegisteredEvents: 'setUnRegisteredEvents',

    // AuthSF
    sfSetAuthSession: 'sfSetAuthSession',
    setMemberIdFromSfAuth: 'setMemberIdFromSfAuth',

    //Invalid Community
    setErrorFetchingCommunityData: 'setErrorFetchingCommunityData',

    //MFA Settings
    setUserMFASettings: 'setUserMFASettings',
    setUserInAmfaGroupValue: 'setUserInAmfaGroupValue',
    setUserInfo: 'setUserInfo',
    setLoginSecuritySettings: 'setLoginSecuritySettings',
    cancelLoginSecurityEdit: 'cancelLoginSecurityEdit',
    setSecurityQuestionsList: 'setSecurityQuestionsList',
    setPasswordComplexityRequirement: 'setPasswordComplexityRequirement',
    setPhoneValidated: 'setPhoneValidated',

    //Connect Plus
    setConnectPlusRedirects: 'setConnectPlusRedirects',

    // Chapter Studio
    setChapterStudioResources: 'setChapterStudioResources',
    setChapterStudioFavorite: 'setChapterStudioFavorite',
    setChapterStudioChapterList: 'setChapterStudioChapterList',
    setChapterStudioSelectedChapter: 'setChapterStudioSelectedChapter',
    setChapterStudioAnnouncements: 'setChapterStudioAnnouncements',

    // Manage Chapter Studio
    setAnnouncementsForManageChapterStudio: "setAnnouncementsForManageChapterStudio",
    setBreadcrumbList: 'setBreadcrumbList',
    setChapterStudioPicklists: 'setChapterStudioPicklists',
    setPastAnnouncementsForManageChapterStudio: "setPastAnnouncementsForManageChapterStudio",

    // Snackbar
    setSnackbar: 'setSnackbar',
    hideSnackbar: 'hideSnackbar',
};
